<template>
    <header class="quiz-header">
        <div class="quiz-header__intro">
            <button
                type="button"
                class="quiz-header__back"
                :title="$t('common.back')"
                :aria-label="$t('common.back')"
                @click="$emit('back')"
            >
                <fa icon="fa-solid fa-chevron-left" />
            </button>
            <div class="quiz-header__copy">
                <h1 class="quiz-header__title">
                    {{ isEditing ? $t('admin.quiz.titleEdit') : $t('admin.quiz.titleNew') }}
                </h1>
                <p class="quiz-header__subtitle">
                    {{ $t('admin.quiz.pageSubtitle') }}
                </p>
            </div>
        </div>

        <div class="quiz-stats" :aria-label="$t('admin.quiz.questionsSection')">
            <article class="quiz-stat">
                <span class="quiz-stat__icon" aria-hidden="true">
                    <fa icon="fa-solid fa-file-lines" />
                </span>
                <div class="quiz-stat__text">
                    <p class="quiz-stat__value">{{ questionLabel }}</p>
                    <p class="quiz-stat__hint">{{ $t('admin.quiz.statsQuestionHint') }}</p>
                </div>
            </article>

            <article class="quiz-stat">
                <span class="quiz-stat__icon" aria-hidden="true">
                    <fa icon="fa-solid fa-list" />
                </span>
                <div class="quiz-stat__text">
                    <p class="quiz-stat__value">{{ alternativeLabel }}</p>
                    <p class="quiz-stat__hint">{{ $t('admin.quiz.statsAlternativeHint') }}</p>
                </div>
            </article>

            <article class="quiz-stat">
                <span class="quiz-stat__icon" aria-hidden="true">
                    <fa icon="fa-solid fa-bullseye" />
                </span>
                <div class="quiz-stat__text">
                    <p class="quiz-stat__value">{{ $t('admin.quiz.minScore') }}</p>
                    <p
                        class="quiz-stat__hint"
                        :class="{ 'quiz-stat__hint--accent': requiredScore }"
                    >
                        {{ scoreLabel }}
                    </p>
                </div>
            </article>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'QuizEditorHeader',
        props: {
            isEditing: {
                type: Boolean,
                default: false,
            },
            questionCount: {
                type: Number,
                default: 0,
            },
            alternativeCount: {
                type: Number,
                default: 0,
            },
            requiredScore: {
                type: Boolean,
                default: false,
            },
            approvalPercentage: {
                type: [Number, String],
                default: 0,
            },
        },
        emits: ['back'],
        computed: {
            questionLabel() {
                if (this.questionCount === 1) {
                    return this.$t('admin.quiz.statsQuestionOne');
                }
                return this.$t('admin.quiz.statsQuestionMany', {
                    n: this.questionCount,
                });
            },
            alternativeLabel() {
                if (this.alternativeCount === 1) {
                    return this.$t('admin.quiz.statsAlternativeOne');
                }
                return this.$t('admin.quiz.statsAlternativeMany', {
                    n: this.alternativeCount,
                });
            },
            scoreLabel() {
                if (!this.requiredScore) {
                    return this.$t('admin.quiz.minScoreOff');
                }
                const value = Number(this.approvalPercentage);
                const percentage = Number.isFinite(value) ? Math.round(value) : 0;
                return `${percentage}%`;
            },
        },
    };
</script>
